export default __webpack_public_path__ + "static/media/blkLand.8bc30555.gif";